import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/utils/ui";

/** Option chips that wrap onto a second line on a phone, so none is clipped. */
export function ChipRow({ label, children, className, ...rest }: { label?: string; children: ReactNode; className?: string; "data-testid"?: string }) {
	return (
		<div className={cn("flex items-center gap-3", className)} {...rest}>
			{label && <span className="shrink-0 text-sm text-muted-foreground">{label}</span>}
			<div role="group" aria-label={label} className="flex min-w-0 flex-wrap gap-1.5 py-0.5">
				{children}
			</div>
		</div>
	);
}

export function Chip({
	selected,
	className,
	...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { selected?: boolean }) {
	return (
		<button
			type="button"
			aria-pressed={selected}
			className={cn(
				"inline-flex min-h-9 shrink-0 items-center rounded-full border px-3.5 text-sm transition-colors sm:min-h-8",
				selected
					? "border-primary bg-secondary font-medium text-secondary-foreground"
					: "border-border-strong text-foreground hover:bg-accent",
				className,
			)}
			{...props}
		/>
	);
}
